/**
 * MS-533/MS-605 — «تفاصيل الفاتورة»: the welcome book's own invoice rows, printed verbatim.
 *
 * The rows are built in ./invoice from the backend's split, never from arithmetic here — see the
 * note at the top of that module for why MS-605 made that the rule.
 */
import {
  PaymentContainer,
  PaymentTitle,
  PaymentRow,
  PaymentLabel,
  PaymentValue,
  PaymentTotal,
  PaymentTotalAmount,
  GuestPortalDetailsPaymentDivider,
} from "./styles";
import { buildInvoice, type InvoiceInput } from "./invoice";

interface InvoiceBreakdownProps extends InvoiceInput {
  isPhone: boolean;
  title?: string;
  /** MS-606: the payment-status page has already been paid, so it cannot say «المستحق». */
  totalLabel?: string;
}

const InvoiceBreakdown = ({
  isPhone,
  title = "تفاصيل الفاتورة",
  totalLabel = "الإجمالي المستحق",
  ...figures
}: InvoiceBreakdownProps) => {
  const invoice = buildInvoice(figures);

  return (
    <PaymentContainer $isPhone={isPhone}>
      <PaymentTitle $isPhone={isPhone}>{title}</PaymentTitle>
      {invoice.nightly && (
        <PaymentRow>
          <PaymentLabel $isPhone={isPhone}>{invoice.nightly.label}</PaymentLabel>
          <PaymentValue $isPhone={isPhone}>{invoice.nightly.amount}</PaymentValue>
        </PaymentRow>
      )}
      {invoice.vat && (
        <PaymentRow>
          <PaymentLabel $isPhone={isPhone}>{invoice.vat.label}</PaymentLabel>
          <PaymentValue $isPhone={isPhone}>{invoice.vat.amount}</PaymentValue>
        </PaymentRow>
      )}
      <GuestPortalDetailsPaymentDivider />
      <PaymentRow>
        <PaymentTotal $isPhone={isPhone}>{totalLabel}</PaymentTotal>
        <PaymentTotalAmount $isPhone={isPhone}>{invoice.total}</PaymentTotalAmount>
      </PaymentRow>
    </PaymentContainer>
  );
};

export default InvoiceBreakdown;
